import { render, staticRenderFns } from "./LbaDialogConfirm.vue?vue&type=template&id=4dcbd01e"
import script from "./LbaDialogConfirm.vue?vue&type=script&lang=js"
export * from "./LbaDialogConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports